import React, { useEffect, useState } from 'react';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import Title from '../../../components/Title';
import Spacer from '../../../components/Spacer';
import { DataGrid } from '@material-ui/data-grid';
import DescriptionIcon from '@mui/icons-material/Description';
import { useNavigate } from 'react-router';
import MissionOrderService from '../../../services/MissionOrderService';
import { Autocomplete, Box, Button, FormControl, Grid, Paper, TextField } from '@mui/material';
import Message from '../../tools/Message';
import SearchIcon from '@mui/icons-material/Search';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 2,
    borderRadius: "8px",
    marginTop: "2%",
    height: "60%",
    boxShadow: "box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;",
  },
  btn: {
    margin: "1% 0.25% 1% 0.25%",
    fontWeight: 600,
  },
}));

export default function MissionOrderTable() {
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
  const [rows, setRows] = useState([]);
  const [message, setMessage] = useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const { open, color, messageInfo } = message;
  const classes = useStyles();
  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }
  const [filter, setFilter] = useState({
      destination: '',
      debut: '',
      fin: '',
      status: '',
      title: '',
      reference: '',
    });
    const [reference, setReference] = useState([]);

  const navigate = useNavigate();
  useEffect(() => {
    setOpenLoadingSimpleBackdrop(true);
    MissionOrderService.findMissionsOM().then((result) => {
      if(result && result.data){
        setRows(result.data?.map((row, index)=>({...row, id:index})));
        setReference(result.data?.map((row) => row.reference));
        setOpenLoadingSimpleBackdrop(false);
      }else{
        setOpenLoadingSimpleBackdrop(false);
      }
    });
  }, []);

  const genegenerateAnnexe = async (planning_id) => {
    setOpenLoadingSimpleBackdrop(true);
    try {
      const response = await MissionOrderService.missionOrderAnnexeGenerate(planning_id);
      const blob = await response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `Annexe_A.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      setMessage({ open: true, color: 'green', messageInfo: 'Annexe généré avec succès' });
    } catch (error) {
      console.error('Erreur lors du téléchargement du PDF :', error);
      setMessage({ open: true, color: 'red', messageInfo: 'Erreur lors de la génération de l\'annexe' });
    } finally {
      setOpenLoadingSimpleBackdrop(false);
    }
  }

  const handleGenerateOM = async (planning_id, categorie, mission_planning_agenda_id) => {
    setOpenLoadingSimpleBackdrop(true);

    try {
        const response = await MissionOrderService.missionOrderGenerate(planning_id , mission_planning_agenda_id, {
            responseType: 'blob' 
        });

        const contentType = response.headers['content-type']; 
        const isZip = contentType === 'application/zip'; 
        const extension = isZip ? 'zip' : 'pdf'; 
        const fileName = `Ordre_Mission.${extension}`;

        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        
        window.URL.revokeObjectURL(url);
        if (categorie === "groupe") genegenerateAnnexe(planning_id);

        setMessage({ open: true, color: 'green', messageInfo: 'Ordre de mission généré avec succès' });

    } catch (error) {
        console.error('Erreur lors du téléchargement du fichier :', error);
        setMessage({ open: true, color: 'red', messageInfo: 'Erreur lors de la génération de l\'ordre de mission' });
    } finally {
        setOpenLoadingSimpleBackdrop(false);
    }
};


    const handleChangeFilter = (e) => {
      const { name, value } = e.target;
      setFilter({ ...filter, [name]: value });
    }

  const columns = [
    { field: 'reference', headerName: 'Réference', width: 148, },
    { field: 'mission_title', headerName: 'Objet de la mission', width: 360, },
    { field: 'lieu', headerName: 'Destination', width: 220, },
    { field: 'date_begin', headerName: 'Date de début', width: 186, renderCell: (params) => {
      return (
        <>
          {new Date(params.row.date_begin).toLocaleDateString()}
        </>
      );
    }
    },
    { field: 'date_end', headerName: 'Date de fin', width: 150, renderCell: (params) => {
      return (
        <>
          {new Date(params.row.date_end).toLocaleDateString()}
        </>
      );
    }
    },
    { field: 'action', headerName: 'Action',   renderCell: (params) => {
      return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button title="Générer l'ordre de mission" onClick={() => handleGenerateOM(params.row.mission_planning_id, params.row.categtype, params.row.mission_planning_agenda_id)} size='small' variant="outlined"
                  color='info'
                  >
              <DescriptionIcon  /> <strong  >OM</strong>
              
                </Button>    
        </div>
      );
    }, width: 121, },
  ];

  const handleFilter = () => {
    setOpenLoadingSimpleBackdrop(true);
    MissionOrderService.filterMissionValidated(filter).then((result) => {
      if (result && result.data) {
        setRows(result.data?.map((row) => ({ ...row, id: row.mission_planning_id })));
        setOpenLoadingSimpleBackdrop(false);
      } else {
        setOpenLoadingSimpleBackdrop(false);
      }
    });
  }


    return (
        <React.Fragment>
        <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
        <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
        
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
        <Grid item xs={12} sm={6} md={11}>
          <label className={classes.labelPosition}>Objet de la mission:</label>
          <FormControl fullWidth variant="outlined" size="small">
               <TextField
                        fullWidth
                        id="title"
                        size="small"
                        variant="outlined"
                        value={filter.title}
                        name="title"
                      onChange={handleChangeFilter}
                      label="Objet de la mission ..."
                      />
          </FormControl>
        </Grid>
        <Grid container xs={12}justifyContent={"flex-end"} >
          <Button
            variant="contained"
            color="primary"
            onClick={handleFilter}
            className={classes.btn}
          >
            <SearchIcon style={{ marginRight: '8px' }} />
            Filtrer
          </Button>
          <Spacer x={4} />
        </Grid>
      </Box>

      <Grid container xs={12} spacing={2} >
        <Grid item xs={12} sm={6} md={3}>
          <label className={classes.labelPosition}>Réference:</label>
          <FormControl fullWidth variant="outlined" size="small">
              <Autocomplete
                  id="tags-outlined"
                  options={reference}
                  sx={{
                    '& .MuiInputBase-root': { height: 40 }, 
                    '& .MuiInputBase-input': { padding: '4px 8px' } 
                  }}
                  getOptionLabel={(option) =>
                    `${option}`
                  }
                  filterSelectedOptions
                  onChange={(event, newValue) => {
                    setFilter({ ...filter, reference: newValue });
                  }
                  }
                  size='small'
                  value={filter.reference}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" size="small" />
                  )}
                />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          Destination :
          <TextField
            fullWidth
            id="destination"
            size="small"
            variant="outlined"
            value={filter.destination}
            name="destination"
          onChange={handleChangeFilter}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          Date de début:
          <TextField
            fullWidth
            id="date_debut"
            size="small"
            variant="outlined"
            type="date"
            value={filter.debut}
            name="debut"
          onChange={handleChangeFilter}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          Date de fin:
          <TextField
            fullWidth
            id="date_fin"
            size="small"
            variant="outlined"
            type="date"
            value={filter.fin}
            name="fin"
          onChange={handleChangeFilter}
          />
        </Grid>
      </Grid>
        <Paper className={classes.paper} variant="outlined">
        <Title>Ordre des Missions</Title>
        <div style={{ height: 600, width: '100%' }}>
          <DataGrid rows={rows} columns={columns} 
           pageSize={7}
           rowsPerPageOptions={[10, 20, 50]}
          disableSelectionOnClick/>
        </div>
        </Paper>
      </React.Fragment>
    )
}